// @ts-check
import { Box, Button, StarIcon, Link } from '~/design-system';
import { Trans } from '@lingui/macro';
import { useCommonLinks } from '../../../pages/imports/_config';
import Layout from '../../Layout/Layout';
import PageSubtitle from '../../Layout/PageSubtitle';
import PageTitle from '../../Layout/PageTitle';
import useProductListUrl from '~/components/useProductListUrl';

/**
 * Renders the import complete page
 * @param {Object} props
 * @param {Object} [props.importData] - the import data
 */
export default function DefaultImportCompletePage({ importData }) {
  const link = useCommonLinks();
  const productListUrl = useProductListUrl({
    productListId: importData?.productListId,
  });
  return (
    <Layout>
      <Box>
        <Box sx={{ textAlign: 'center' }}>
          <StarIcon sx={{ height: 120, width: '120px' }} />
          <PageTitle>
            <Trans>Import complete</Trans>
          </PageTitle>
          <PageSubtitle>
            <Trans>Your data was successfully imported.</Trans>
          </PageSubtitle>
          {productListUrl && (
            <Box sx={{ marginTop: 3 }}>
              <Link href={productListUrl} target="_blank">
                <Trans>Open products list</Trans>
              </Link>
            </Box>
          )}
          <Box sx={{ marginTop: 3 }}>
            <Link
              href={importData?.outputUrl}
              target="_blank"
              noopener
              noreferrer
            >
              Download imported changes report
            </Link>
          </Box>
          <Box sx={{ marginTop: 3 }}>
            <Button variant="primary" to={link.root()}>
              <Trans>View imports</Trans>
            </Button>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}
